export default class AppConstants {

  // EXTERNAL LINKS
  static EXTERNAL_LINK_NEW_CLIENT = 'http://www2.safras.com.br/plataforma/';
  static URL_YOUTUBE_WATCH = 'https://www.youtube.com/watch';
  static URL_YOUTUBE_EMBED = 'https://www.youtube.com/embed/';
  static URL_SOUNDCLOUD_EMBED = 'https://w.soundcloud.com/player/?url=https://soundcloud.com/';
  static URL_SPOTIFY_EMBED = 'https://open.spotify.com/embed/episode/';

  // PARAMS KEY
  static PARAMS_TOKEN = 'access_token';

  static CUSTOM_TABLE_DEFAULT_HEIGHT = '600px'

  // COPY COPYRIGHT
  static COPYRIGHT_TEXT_CLIPBOARD = 'Copyright 2020 Safras Consultoria - Todos os direitos reservados';

  // ********* USER ROLE PROFILE *******************
  static USER_ROLE_ADM = 'admin';
  static USER_ROLE_EDITOR = 'editor';
  static USER_ROLE_PUBLISHER = 'publisher';

  // ********* EVENTS NAME *******************
  static EVENT_LOGIN = 'loginEvent';

  // ********* TIMEOUT VALUES *******************
  static API_REST_TIMEOUT = 15000;

  // ********* DEFAULT PAGINATOR DATA *******************
  static PAGINATOR_DEFAULT_PAGE_SIZE = 10;
  static PAGINATOR_DEFAULT_LIMIT = 20;
  static PAGINATOR_DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 200, 500, 1000];
  static PAGINATOR_DEFAULT_LIMIT_MEDIA = 100;

  // ********* LOCAL STORAGE KEYS *******************
  static LOCAL_STORAGE_HAS_LOGGED_IN = 'hasLoggedIn';
  static LOCAL_STORAGE_CURRENT_USER = 'currentUser';
  static LOCAL_STORAGE_CURRENT_ORIGIN = 'currentOrigin';
  static LOCAL_STORAGE_DRAFT_NEWS = 'draftNews';
  static LOCAL_STORAGE_VISITOR = 'visitor';

  // ********* NAVIGATION URL *******************
  static NAVIGATION_PAGE_HOME = '/home';
  static NAVIGATION_PAGE_LOGIN = '/login';
  static NAVIGATION_PAGE_REGISTER = '/pages/register';
  static NAVIGATION_PAGE_VERSION = '/version';
  static NAVIGATION_PAGE_FORGOT_PASSWORD = '/forgot-password';
  static NAVIGATION_PAGE_RESET_PASSWORD = '/reset-password';
  static NAVIGATION_PAGE_ERROR_404 = '/pages/error-404';
  static NAVIGATION_PAGE_ERROR_500 = '/pages/error-500';
  static NAVIGATION_PAGE_CALLBACK = '/pages/callback';
  static NAVIGATION_PAGE_COMINGSOON = '/pages/comingsoon';
  static NAVIGATION_PAGE_BROWSER_NOT_SUPPORT = '/pages/browser-not-support';
  static NAVIGATION_PAGE_MAINTENANCE = '/pages/maintenance';

  static NAVIGATION_PAGE_MY_ACCOUNT = '/my-account';

  static NAVIGATION_PAGE_CALENDAR = '/pages/calendar';
  static NAVIGATION_PAGE_SEND_NEWS = '/news/send';
  static NAVIGATION_PAGE_MANAGE_NEWS = '/news/manage';
  static NAVIGATION_PAGE_REPORT_NEWS = '/news/report';
  static NAVIGATION_PAGE_STATISTICS = '/news/statistics';
  static NAVIGATION_PAGE_ASK_ANALYST = '/pages/ask-analyst';
  static NAVIGATION_PAGE_ATTENDANCE = '/pages/attendance';
  static NAVIGATION_PAGE_ADM_AUTH_TOKEN = '/admin/auth-token';
  static NAVIGATION_PAGE_ADM_CLIENT_ACCESS = '/admin/client-access';
  static NAVIGATION_PAGE_ADM_AUDITLOG = '/admin/auditlog';
  static NAVIGATION_PAGE_ADM_USER = '/admin/user';
  static NAVIGATION_PAGE_ADM_USER_REGISTER = '/admin/user/register';
  static NAVIGATION_PAGE_ADM_USER_CLIENT = '/admin/user-client';
  static NAVIGATION_PAGE_ADM_USER_CLIENT_REGISTER = '/admin/user-client/register';
  static NAVIGATION_PAGE_ADM_USER_HEADER = '/admin/user-header';
  static NAVIGATION_PAGE_ADM_USER_HEADER_REGISTER = '/admin/user-header/register';
  static NAVIGATION_PAGE_ADM_SUBJECT = '/admin/subjects';
  static NAVIGATION_PAGE_ADM_SUBJECT_REGISTER = '/admin/subjects/register';
  static NAVIGATION_PAGE_ADM_ASSET_REFERENCE = '/admin/asset-reference';
  static NAVIGATION_PAGE_ADM_ASSET_REFERENCE_REGISTER = '/admin/asset-reference/register';
  static NAVIGATION_PAGE_ADM_TAG = '/admin/tags';
  static NAVIGATION_PAGE_ADM_TAG_REGISTER = '/admin/tags/register';
  static NAVIGATION_PAGE_ADM_APP_CONFIG_RULES = '/admin/app-config-rules';
  static NAVIGATION_PAGE_ADM_APP_CONFIG_RULES_REGISTER = '/admin/app-config-rules/register';
  static NAVIGATION_PAGE_ADM_VECTORIZATION_MANAGEMENT = '/admin/vectorization-management';
  static NAVIGATION_PAGE_ADM_VECTORIZATION_MANAGEMENT_REGISTER = '/admin/vectorization-management/register';
  static NAVIGATION_PAGE_ADM_CONTENT_PRIVATE_CONF = '/admin/content-private-conf';
  static NAVIGATION_PAGE_ADM_CONTENT_PRIVATE_CONF_REGISTER = '/admin/content-private-conf/register';
  static NAVIGATION_PAGE_ADM_CATEGORY = '/admin/category';
  static NAVIGATION_PAGE_ADM_CATEGORY_REGISTER = '/admin/category/register';
  static NAVIGATION_PAGE_ADM_HAT = '/admin/hat';
  static NAVIGATION_PAGE_ADM_HAT_REGISTER = '/admin/hat/register';
  static NAVIGATION_PAGE_ADM_INSTITUTION = '/admin/institution';
  static NAVIGATION_PAGE_ADM_INSTITUTION_REGISTER = '/admin/institution/register';
  static NAVIGATION_PAGE_ADM_PUSHCONFIG = '/admin/push-config';
  static NAVIGATION_PAGE_ADM_PUSHCONFIG_REGISTER = '/admin/push-config/register';
  static NAVIGATION_PAGE_ADM_ACRONYMS = '/admin/acronyms';
  static NAVIGATION_PAGE_ADM_ACRONYMS_REGISTER = '/admin/acronyms/register';
  static NAVIGATION_PAGE_ADM_ADOBE_ACCOUNT = '/admin/adobe-account';
  static NAVIGATION_PAGE_ADM_ADOBE_ACCOUNT_REGISTER = '/admin/adobe-account/register';
  static NAVIGATION_PAGE_ADM_ORIGIN = '/admin/origin';
  static NAVIGATION_PAGE_ADM_ORIGIN_REGISTER = '/admin/origin/register';
  static NAVIGATION_PAGE_ADM_SIGA_INSTANCE = '/admin/siga-instance';
  static NAVIGATION_PAGE_ADM_SIGA_INSTANCE_REGISTER = '/admin/siga-instance/register';
  static NAVIGATION_PAGE_IMAGE_LIBRARY = '/admin/image-library';
  static NAVIGATION_PAGE_IMAGE_LIBRARY_REGISTER = '/admin/image-library/register';
  static NAVIGATION_PAGE_ADM_PERIODICITY = '/admin/periodicity';
  static NAVIGATION_PAGE_ADM_PERIODICITY_REGISTER = '/admin/periodicity/register';
  static NAVIGATION_PAGE_ADM_CLIENT_GROUP = '/admin/client-group';
  static NAVIGATION_PAGE_ADM_CLIENT_GROUP_REGISTER = '/admin/client-group/register';
  static NAVIGATION_PAGE_ADM_TOPIC = '/admin/topic';
  static NAVIGATION_PAGE_ADM_TOPIC_REGISTER = '/admin/topic/register';
  static NAVIGATION_PAGE_ADM_CHARACTERISTIC = '/admin/characteristic';
  static NAVIGATION_PAGE_ADM_CHARACTERISTIC_REGISTER = '/admin/characteristic/register';
  static NAVIGATION_PAGE_ADM_PACKAGE = '/admin/package';
  static NAVIGATION_PAGE_ADM_PACKAGE_REGISTER = '/admin/package/register';
  static NAVIGATION_PAGE_ADM_COUNTRY = '/admin/country';
  static NAVIGATION_PAGE_ADM_COUNTRY_REGISTER = '/admin/country/register';
  static NAVIGATION_PAGE_ADM_LAYOUT = '/admin/layout';
  static NAVIGATION_PAGE_ADM_LAYOUT_REGISTER = '/admin/layout/register';
  static NAVIGATION_PAGE_ADM_LAYOUT_WDMA_HIST = '/admin/layout-wdma-hist';
  static NAVIGATION_PAGE_ADM_LAYOUT_WDMA_HIST_REGISTER = '/admin/layout-wdma-hist/register';
  static NAVIGATION_PAGE_ADM_LANGUAGE = '/admin/language';
  static NAVIGATION_PAGE_ADM_LANGUAGE_REGISTER = '/admin/language/register';
  static NAVIGATION_PAGE_ADM_CONTENT = '/admin/content';
  static NAVIGATION_PAGE_ADM_CONTENT_REGISTER = '/admin/content/register';
  static NAVIGATION_PAGE_ADM_CLIENT_SIGNATURE = '/admin/client-signature';
  static NAVIGATION_PAGE_ADM_CLIENT_SIGNATURE_REGISTER = '/admin/client-signature/register';
  static NAVIGATION_PAGE_ADM_COMMODITY = '/admin/commodity';
  static NAVIGATION_PAGE_ADM_COMMODITY_REGISTER = '/admin/commodity/register';
  static NAVIGATION_PAGE_ADM_CHANNEL = '/admin/channel';
  static NAVIGATION_PAGE_ADM_CHANNEL_REGISTER = '/admin/channel/register';
  static NAVIGATION_PAGE_ADM_CONTENT_RELEVANCE = '/admin/content-relevance';
  static NAVIGATION_PAGE_ADM_CONTENT_RELEVANCE_REGISTER = '/admin/content-relevance/register';
  static NAVIGATION_PAGE_ADM_REPORT_TYPE = '/admin/reportType';
  static NAVIGATION_PAGE_ADM_REPORT_TYPE_GROUPS = '/admin/reportTypeGroups';
  static NAVIGATION_PAGE_ADM_REPORT_TYPE_REGISTER = '/admin/reportType/register';
  static NAVIGATION_PAGE_ADM_REPORT_TYPE_GROUPS_REGISTER = '/admin/reportTypeGroups/register';
  static NAVIGATION_PAGE_ADM_LOGICAL_USER = '/admin/logicalUser';
  static NAVIGATION_PAGE_ADM_LOGICAL_USER_REGISTER = '/admin/logicalUser/register';
  static NAVIGATION_PAGE_ADM_USER_CORE = '/admin/user-core';
  static NAVIGATION_PAGE_ADM_USER_CORE_REGISTER = '/admin/user-core/register';
  static NAVIGATION_PAGE_ADM_LEADS = '/admin/leads';
  static NAVIGATION_PAGE_ADM_SERVICE_ACCESS_MANAGER = '/admin/service-access-manager';
  static NAVIGATION_PAGE_ADM_SERVICE_ACCESS_MANAGER_REGISTER = '/admin/service-access-manager/register';
  static NAVIGATION_PAGE_ADM_ACCEPTOR_LOGS = '/admin/acceptor-logs';

  // ********* API URI *******************
  static URL_AUTH_LOGIN = 'auth/signin';
  static URL_AUTH_LOGIN_TWO_FACTOR_AUTH = 'auth/signinTwoFactorAuth';
  static URL_AUTH_LOGIN_VALIDATE_TOKEN = 'auth/validateTwoFactorAuthToken';

  static URL_VERSION = 'version';
  static URL_SEND_NEWS = 'news';
  static URL_SEND_YOUTUBE = 'news/upload-youtube';
  static URL_MANAGE_NEWS = 'news/manage';
  static URL_MANAGE_NEWS_REDUCED = 'news/manage/reduced';
  static URL_NEWS_UPDATE_STATUS_EDITING = 'news/update-status/editing';
  static URL_NEWS_CANCEL_EDITING = 'news/update-status/cancel-editing';
  static URL_NEWS_GET_DETAIL = 'news';
  static URL_NEWS_SYNCHRONIZE = 'news/synchronize';
  static URL_NEWS_SYNCHRONIZE_RANGE = 'news/sync/elastic/month';
  static URL_NEWS_SYNC_ELASTIC_JOB = 'news/sync/elastic/job';
  static URL_NEWS_RECONCILE_ELASTIC = 'news/sync/elastic/reconcile';
  static URL_NEWS_EVENT_STATUS_STATISTIC = 'news/eventStatus/statistc';
  static URL_NEWS_SCHEDULE = 'news/schedule';
  static URL_NEWS_PUBLISH = 'news/publish';
  static URL_NEWS_CANCEL = 'news/cancel';
  static URL_NEWS_DISABLE = 'news/disable';
  static URL_NEWS_READ_DOCUMENT = 'news/read-document';
  static URL_NEWS_DOWNLOAD_DOCUMENT = 'news/download-document';
  static URL_NEWS_DELETE_ALL_DRAFTS = 'news/delete/all/draft';
  static URL_NEWS_RE_INDEX = 'news/sync/re-index';
  static URL_NEWS_RECALCULATE_RELEVANCE = 'news/sync/recalculate-relevance';
  static URL_NEWS_REFRESH_ELASTIC = 'news/elastic/refresh';
  static URL_NEWS_REMOVE_FROM_ELASTIC = 'news/elastic/remove-data';
  static URL_NEWS_RESTORE_TO_ELASTIC = 'news/elastic/restore';
  static URL_NEWS_DELETE_USER_TEMPLATE = 'news/delete/user-template';
  static URL_NEWS_DETAIL_USER_CORE = 'news/detail/user-core';
  static URL_NEWS_TRANSLATE = 'news/translate';
  static URL_NEWS_AI_EDIT_BODY = 'news/ai/edit-body';
  static URL_NEWS_AI_SUGGESTIONS = 'news/ai/suggestions';
  static URL_NEWS_AI_TAGS_SUGGESTIONS = 'news/ai/tags/suggestions';
  static URL_NEWS_AI_HAT_SUGGESTIONS = 'news/ai/hat/suggestions';
  static URL_NEWS_AI_TITLE_SUGGESTIONS = 'news/ai/title/suggestions';
  static URL_NEWS_AI_SUMMARY_SUGGESTIONS = 'news/ai/summary/suggestions';
  static URL_NEWS_AI_BODY_CREATE = 'news/ai/body/create';
  static URL_NEWS_AI_BODY_IMPROVE = 'news/ai/body/improve';
  static URL_NEWS_VECTORIZE = 'news/request/vectorize';
  static URL_NEWS_PROCESSING_STATUS = 'news';
  static URL_NEWS_PROCESSING_STATUS_RETRY = 'news';
  static URL_NEWS_SYNC_WITH_VECTORIZATION = 'news/sync/vectorization';

  static URL_SEND_IMPORTED_CALENDAR_EVENTS = 'news/imported-calendar-events';
  static URL_CHECK_EVENT_CONFLICTS = 'news/imported-calendar-check-event-conflicts';


  static URL_FORGOT_PASSWORD = 'auth/forgot/password';
  static URL_RESET_PASSWORD = 'auth/reset/password';

  static URL_CALENDAR_GETALL = 'calendar/all';
  static URL_CALENDAR_DETAIL = 'calendar/detail';
  static URL_CALENDAR_REGISTER = 'calendar/register';
  static URL_CALENDAR_UPDATE = 'calendar/update';
  static URL_CALENDAR_DELETE = 'calendar/delete';
  static URL_CALENDAR_IMPORT = 'calendar/import';

  static URL_IMAGE_LIBRARY = 'media';

  static URL_SUBSCRIBER_GETALL = 'assinatura/all';
  static URL_SUBSCRIBER_REPORT = 'assinatura/download/report';

  static URL_CONTACT_GETALL = 'contact';
  static URL_CONTACT_REPORT = 'contact/download/report';

  static URL_NEWS_REPORT_CURRENT_USER = 'newsreport/current-user';
  static URL_NEWS_REPORT_USER = 'newsreport/all';
  static URL_NEWS_REPORT_DATE = 'newsreport/date';
  static URL_NEWS_REPORT_DOWNLOAD = 'newsreport/download/report';
  static URL_ANALYTICS_SYSTEM_CONTENT = 'newsreport/analytics/system-content';
  static URL_ANALYTICS_SYSTEM_CONTENT_REPORT_DOWNLOAD = 'newsreport/analytics/system-content/download/report';
  static URL_CONTROL_CONTENT_VIEW = 'newsreport/control-content-view';
  static URL_CONTROL_CONTENT_VIEW_REPORT_DOWNLOAD = 'newsreport/control-content-view/download/report';

  static URL_ASK_ANALYST = 'askAnalyst';
  static URL_ASK_ANALYST_BY_USER = 'askAnalyst/all/user';
  static URL_ASK_ANALYST_REPORT = 'askAnalyst/download/report';
  static URL_ASK_ANALYST_NEW_ANSWER = 'askAnalyst/new/answer';

  static URL_ORIGIN = 'origin';
  static URL_ORIGIN_SYNC = 'origin/sync';
  static URL_ORIGIN_REPORT = 'origin/download/report';

  static URL_SIGA_INSTANCE = 'siga-instance';

  static URL_CATEGORY = 'category';
  static URL_CATEGORY_REPORT = 'category/download/report';

  static URL_TAG = 'tag';
  static URL_TAG_REPORT = 'tag/download/report';

  static URL_APP_CONFIG_RULES = 'app-config-rules';
  static URL_APP_CONFIG_RULES_REPORT = 'app-config-rules/download/report';

  static URL_VECTORIZATION_MANAGEMENT = 'vectorization-management';
  static URL_VECTORIZATION_MANAGEMENT_REPORT = 'vectorization-management/download/report';

  static URL_CONTENT_PRIVATE_CONFIG = 'content-private-conf';
  static URL_CONTENT_PRIVATE_CONFIG_UPDATE_API_CACHE = 'content-private-conf/update/api-cache';
  static URL_CONTENT_PRIVATE_CONFIG_REPORT = 'content-private-conf/download/report';

  static URL_HAT = 'hat';
  static URL_HAT_REPORT = 'hat/download/report';
  static URL_INSTITUTION = 'institution';
  static URL_INSTITUTION_REPORT = 'institution/download/report';

  static URL_PUSH_CONFIG_GETALL = 'pushConfig/all';
  static URL_PUSH_CONFIG_DETAIL = 'pushConfig/detail';
  static URL_PUSH_CONFIG_DELETE = 'pushConfig/delete';
  static URL_PUSH_CONFIG_REGISTER = 'pushConfig/register';
  static URL_PUSH_CONFIG_REPORT = 'pushConfig/download/report';

  static URL_ACRONYMS = 'acronyms';
  static URL_ACRONYMS_DETAIL_NAME = 'acronyms/detail/name';
  static URL_ACRONYMS_REPORT = 'acronyms/download/report';

  static URL_USER_HEADER = 'userHeader';
  static URL_USER_HEADER_REPORT = 'userHeader/download/report';

  static URL_AUDITLOG = 'auditlog';
  static URL_AUDITLOG_REPORT = 'auditlog/download/report';

  static URL_AUTHTOKEN = 'client/auth-token/findall';
  static URL_AUTHTOKEN_DELETE = 'client/auth-token';

  static URL_SENDMAIL = 'sendmail';
  static URL_SENDMAIL_REPORT = 'sendmail/download/report';
  static URL_SENDMAIL_FORCE_SEND = 'sendmail';

  static URL_SENDPUSH = 'sendpush';
  static URL_SENDPUSH_REPORT = 'sendpush/download/report';

  static URL_DEMOREQUEST = 'client/demo-request';
  static URL_DEMOREQUEST_REPORT = 'client/demoRequest/download/report';
  static URL_TOTAL_DEMOREQUEST = 'client/demoRequest/total-demo-request';
  static URL_DEMOREQUEST_REPORT_DATE = 'client/demoRequest/report-by-date';
  static URL_DEMOREQUEST_REPORT = 'client/demoRequest/download/report';

  static URL_SENDLEAD = 'client/leads/send-lead';
  static URL_TOTAL_SENDLEAD = 'client/leads/total-send-lead';
  static URL_LEADS_REPORT_DATE = 'client/leads/report-by-date';
  static URL_SENDLEAD_REPORT = 'client/leads/send-lead/download/report';

  static URL_DELETED_CLIENT = 'client/findall/deleted-clients';
  static URL_DELETED_CLIENT_REPORT = 'client/deleted-clients/download/report';

  static URL_SUBJECTS = 'subject';
  static URL_SUBJECTS_UPDATE_API_CACHE = 'subject/update/api-cache';
  static URL_SUBJECTS_REPORT = 'subject/download/report';

  static URL_TRANSLATION_CONFIG = 'translation-config';
  static URL_TRANSLATION_CONFIG_SAVE_ALL = 'translation-config/save-all';

  static URL_ASSET_REFERENCE = 'asset-reference';
  static URL_ASSET_REFERENCE_REPORT = 'asset-reference/download/report';

  static URL_GEOLOCATION = 'geolocation';
  static URL_IMPORT_IPV4_GEOLOCATION_DATABASE = 'geolocation/importDatabase/ipv4';
  static URL_IMPORT_IPV6_GEOLOCATION_DATABASE = 'geolocation/importDatabase/ipv6';
  static URL_IMPORT_ASN_GEOLOCATION_DATABASE = 'geolocation/importDatabase/asn';
  static URL_GEOLOCATION_IMPORT_STATUS = 'geolocation/importDatabase/status';

  static URL_MDTP_PROVIDER_STATUS_ALL = 'news/mdtp-provider/status/all';
  static URL_MDTP_PROVIDER_STATUS_JWT_RESEND = 'news/mdtp-provider/jwt/resend';

  static URL_CLIENTS = 'client';
  static URL_CLIENTS_DETAIL = 'client/detail';
  static URL_CLIENTS_REPORT = 'client/download/report';
  static URL_CLIENTS_SYNC = 'client/sync';
  static URL_CLIENTS_GET_EXPIRED = 'client/get-expired-clients';
  static URL_CLIENTS_DISABLE_EXPIRED = 'client/disable-expired-clients';
  static URL_CLIENTS_EXPIRED_TO_FREE = 'client/expired-clients-to-free';
  static URL_CLIENTS_FILTER_RIGHTS = 'client/find/filterRights';
  static URL_CLIENTS_ACCESS_SYSTEM = 'client/spent-time/system';
  static URL_CLIENTS_ACCESS_SYSTEM_REPORT = 'client/spent-time/system/report';
  static URL_CLIENTS_DEVICE_ACCESS_SYSTEM = 'client/spent-time/system/statistics/device';
  static URL_CLIENTS_BROWSER_ACCESS_SYSTEM = 'client/spent-time/system/statistics/browser';
  static URL_CLIENTS_OPERATING_SYSTEM_ACCESS_SYSTEM = 'client/spent-time/system/statistics/operating-system';
  static URL_CLIENTS_COUNTRY_ACCESS_SYSTEM = 'client/spent-time/system/statistics/country-access';
  static URL_UPDATE_CLIENT_PROFILE = 'client/update-client-profile';
  static URL_UPDATE_CLIENT_PROFILE_REPORT = 'client/update-client-profile/download/report';
  static URL_CLIENTS_SENDMAIL_FIRST_ACCESS = 'client/send-mail/first-access';

  static URL_LOGICAL_NUMBER = 'logicalNumber';
  static URL_LOGICAL_NUMBER_DETAIL = 'logicalNumber/detail';
  static URL_LOGICAL_NUMBER_SYNC = 'logicalNumber/syncNl';
  static URL_LOGICAL_NUMBER_REPORT = 'logicalNumber/download/report';

  static URL_USER_CONTRIB = 'user';
  static URL_USER_CONTRIB_UPDATE = 'user/update';
  static URL_USER_CONTRIB_REPORT = 'user/download/report';
  static URL_USER_CONTRIB_SEND_NEW_PASSWORD = 'user/send-new-password';
  static URL_USER_CONTRIB_SEND_EMAIL_FIRST_ACCESS = 'user/send-email-first-access';
  static URL_USER_CONTRIB_CHANGE_PASSWORD = 'user/password/change';
  static URL_USER_CONTRIB_UPDATE_USER_CONFIG = 'user/update/config';
  static URL_USER_CONTRIB_UPDATE_SENDNEWS_CONFIG = 'user/update/sendnews/config';
  static URL_USER_CONTRIB_FORM_DETAIL = 'user/form/detail';
  static URL_USER_CONTRIB_CONFIG = 'user/detail/config';
  static URL_USER_CONTRIB_UPDATE_MY_ACCOUNT_GENERAL = 'user/update/my-account/general';
  static URL_USER_CONTRIB_UPDATE_MY_ACCOUNT_SHORTCUT = 'user/update/my-account/shortcut';
  static URL_USER_CONTRIB_UPDATE_MY_ACCOUNT_CONFIG = 'user/update/my-account/config';
  static URL_USER_ATTENDANCE = 'user/attendance';

  static URL_USER_CONTRIB_GETALL = 'userContrib/all';
  static URL_USER_CONTRIB_DETAIL = 'userContrib/detail';
  static URL_USER_CONTRIB_DELETE = 'userContrib/delete';
  static URL_USER_CONTRIB_REGISTER = 'userContrib/register';

  static URL_PERIODICITY = 'periodicity';
  static URL_PERIODICITY_REPORT = 'periodicity/download/report';

  static URL_CLIENT_GROUP = 'clientGroup';
  static URL_CLIENT_GROUP_REPORT = 'clientGroup/download/report';

  static URL_TOPIC = 'topic';
  static URL_TOPIC_REPORT = 'topic/download/report';

  static URL_CHARACTERISTIC = 'characteristic';
  static URL_CHARACTERISTIC_REPORT = 'characteristic/download/report';

  static URL_PACKAGE = 'package';
  static URL_PACKAGE_REPORT = 'package/download/report';

  static URL_COUNTRY = 'country';
  static URL_COUNTRY_REPORT = 'country/download/report';

  static URL_LAYOUT = 'layout';
  static URL_LAYOUT_UPDATE = 'layout/update';
  static URL_LAYOUT_REPORT = 'layout/download/report';
  static URL_LAYOUT_CHECK_SAVED_NEWS = 'layout/check/saved-news';
  static URL_LAYOUT_WDMA_HIST = 'layout/wdma-hist';
  static URL_LAYOUT_WDMA_HIST_ALL = 'layout/wdma-hist/all';

  static URL_LANGUAGE = 'language';
  static URL_LANGUAGE_REPORT = 'language/download/report';

  static URL_CONTENT = 'content';
  static URL_CONTENT_API_CACHE = 'content/update/api-cache';
  static URL_CONTENT_REPORT = 'content/download/report';

  static URL_CLIENT_SIGNATURE = 'client-signature';
  static URL_CLIENT_SIGNATURE_API_CACHE = 'client-signature/update/api-cache';
  static URL_CLIENT_SIGNATURE_REPORT = 'client-signature/download/report';
  static URL_CLIENT_SIGNATURE_SYNC = 'client-signature/sync/sigaweb';

  static URL_COMMODITY_GETALL = 'commodityReport/all';
  static URL_COMMODITY_DETAIL = 'commodityReport/detail';
  static URL_COMMODITY_DELETE = 'commodityReport/delete';
  static URL_COMMODITY_REGISTER = 'commodityReport/register';
  static URL_COMMODITY_REPORT = 'commodityReport/download/report';

  static URL_CHANNEL = 'channel';
  static URL_CHANNEL_REPORT = 'channel/download/report';

  static URL_CONTENT_RELEVANCE = 'content-relevance';
  static URL_CONTENT_RELEVANCE_REPORT = 'content-relevance/download/report';

  static URL_REPORT_TYPE = 'reportType';
  static URL_REPORT_TYPE_REPORT = 'reportType/download/report';

  static URL_REPORT_TYPE_GROUPS = 'reportTypeGroups';
  static URL_REPORT_TYPE_GROUPS_REPORT = 'reportTypeGroups/download/report';

  static URL_ADOBE_ACCOUNT = 'adobe-account';
  static URL_ADOBE_ACCOUNT_REPORT = 'adobe-account/download/report';
  static URL_ADOBE_ACCOUNT_RESET_COUNTER = 'adobe-account/reset/counter';

  static URL_SERVICE_ACCESS_MANAGER = 'service-access-manager';
  static URL_SERVICE_ACCESS_MANAGER_REPORT = 'service-access-manager/download/report';
  static URL_SERVICE_ACCESS_MANAGER_GENERATE_NEW_TOKEN = 'service-access-manager/generate/new-token';

  static URL_USER_CORE = 'user-core';
  static URL_USER_CORE_REPORT = 'user-core/download/report';

  static URL_ACCEPTOR_LOGS = 'acceptor/find-all';

  static URL_DROPDOWN_ORIGIN = 'dropdown/origin';
  static URL_DROPDOWN_PROFIILE = 'dropdown/profile';
  static URL_DROPDOWN_CLIENT_PROFILE = 'dropdown/client-profile';
  static URL_DROPDOWN_SUBJECT = 'dropdown/subject';
  static URL_DROPDOWN_REPORT_TYPE_GROUPS = 'dropdown/reportTypeGroups';
  static URL_DROPDOWN_SUBJECT_SAFRAS_PLATFORM = 'dropdown/subject/safrasplatform';
  static URL_DROPDOWN_ALL_USERHEADER = 'dropdown/all/userheader';
  static URL_DROPDOWN_USERHEADER = 'dropdown/userheader';
  static URL_DROPDOWN_TAG = 'dropdown/tag';
  static URL_DROPDOWN_COUNTRY = 'dropdown/country';
  static URL_DROPDOWN_LANGUAGE = 'dropdown/language';
  static URL_DROPDOWN_LOGICAL_NUMBER = 'dropdown/logicalNumber';
  static URL_DROPDOWN_TYPE_MESSAGES = 'dropdown/typemessages';
  static URL_DROPDOWN_EVENT_STATUS = 'dropdown/event_status';
  static URL_DROPDOWN_USERS = 'dropdown/users';
  static URL_DROPDOWN_USER_SIGNATURE = 'dropdown/user-signature';
  static URL_DROPDOWN_USER_ACRONYMS = 'dropdown/acronyms';
  static URL_DROPDOWN_HAT = 'dropdown/hat';
  static URL_DROPDOWN_REPORT_TYPE = 'dropdown/reportType';
  static URL_DROPDOWN_CONTENT = 'dropdown/content';
  static URL_DROPDOWN_CONTENT_SUBJECT = 'dropdown/content-subject';
  static URL_DROPDOWN_CONTENT_SUBJECT_USERRULE = 'dropdown/content-subject/user-rule';
  static URL_DROPDOWN_COMMODITY = 'dropdown/commodity';
  static URL_DROPDOWN_PACKAGE = 'dropdown/package';
  static URL_DROPDOWN_CHARACTERISTIC = 'dropdown/characteristic';
  static URL_DROPDOWN_PERIODICITY = 'dropdown/periodicity';
  static URL_DROPDOWN_CHANNEL = 'dropdown/channel';
  static URL_DROPDOWN_CHANNEL_ORIGIN = 'dropdown/channelByOrigin';
  static URL_DROPDOWN_AUDITLOG_ACTION = 'dropdown/auditlog-action';
  static URL_DROPDOWN_AUDITLOG_NAME = 'dropdown/auditlog-name';
  static URL_DROPDOWN_CATEGORY = 'dropdown/category';
  static URL_DROPDOWN_CATEGORY_CHANNEL = 'dropdown/category-channel';
  static URL_DROPDOWN_CLIENT_GROUP = 'dropdown/client-group';
  static URL_DROPDOWN_PLATFORM_LOCATION = 'dropdown/platform-location';
  static URL_DROPDOWN_CLIENT_SIGNATURES = 'dropdown/client-signatures';
  static URL_DROPDOWN_CLIENT_REGISTER_SYSTEM_FROM = 'dropdown/client-registerSystemFrom';
  static URL_DROPDOWN_TOPIC = 'dropdown/topic';
  static URL_DROPDOWN_PLATFORM_SYSTEM_TYPE = 'dropdown/platform-system-type';
  static URL_DROPDOWN_CHART_EVENTS = 'dropdown/chart-events';
  static URL_DROPDOWN_CHART_MARKET = 'dropdown/chart-market';
  static URL_DROPDOWN_ASSET_REFERENCE = 'dropdown/asset-reference';
  static URL_DROPDOWN_USER_CATEGORIES_FIELD = 'dropdown/user-categories-field';
  static URL_DROPDOWN_USER_CORE = 'dropdown/user-core';
  static URL_DROPDOWN_PUBLISHER_SERVICES = 'dropdown/publisher-services';
  static URL_DROPDOWN_MDTP_PROVIDER_SERVICE = 'dropdown/mdtp-provider-service';
  static URL_DROPDOWN_PUSH_SERVICE_TYPE = 'dropdown/push-service-type';

  // ********* URL DRODPOWN *******************
  static URL_DROPDOWN_AGENCY_FIND_ALL = 'dropdown/agency';

  // ********* BUS EVENT NAME *******************
  static BUS_EVENT_CLEAR_FILTER = 'clearFilter';

  // THEME TYPE
  static THEME_LIGHT = 'light';
  static THEME_DARK = 'dark';

  // Device Type
  static DEVICE_TYPE_MOBILE = 0;
  static DEVICE_TYPE_DESKTOP = 1;

  static PLATFORM_ANDROID = 0;
  static PLATFORM_IOS = 1;
  static PLATFORM_OTHER = 2;

  // ENUMS
  static NEWS_LAYOUT = {
    NEWS: 1,
    FLASHES: 2,
    PODCAST: 3,
    TVCAST: 4,
    REPORT: 5,
    EVENT: 6,
  };

  static ACTIVE = {
    ALL: 1,
    TRUE: 2,
    FALSE: 3
  }

  static CONTACT_TYPE = ['Contact', 'Subscribe', 'Attendance', 'Lost Access'];

  static IMPORTANT = {
    INFO: { id: 0, name: 'Padrão' },
    IMPORTANT: { id: 1, name: 'Importante' },
  };

  static ORIGINS = {
    AGENCIA_CMA: 131,
    AGENCIA_CMA_LATAM: 132,
    AGENCIA_CMA_APP: 217,
    AGENCIA_CMA_PLATFORM: 241,
    AGENCIA_CMA_PLATFORM_MOBILE: 244,
    SAFRAS_CONNECT_APP: 278,
    SAFRAS_PLATFORM: 250,
    AGENCIA_SAFRAS_APP: 219,
    SAFRAS: 54,
    SAFRAS_FINANCIAL: 247,
    CMA_MARKETS: 700,
    SAFRAS_NEWS: 122
  }

  static EVENT_STATUS = {
    ALL: 100,
    PUBLISHED: 1,
    SAVED: 2,
    SCHEDULED: 3,
    REVIEW: 4,
    CANCELED: 5,
    EDITING: 6,
    DRAFT: 500,
    SHARED: 900,
    TEMPLATE: 1000
  };

  // Itens do menu "Publicações" com total zerado, exibidos até a contagem do backend chegar
  // (mesma lista e ordem de getEventStatusArray no publisher backend, com status=true)
  static EVENT_STATUS_MENU = [
    { id: this.EVENT_STATUS.PUBLISHED, name: 'Publicado', icon: 'MailIcon', i18n: 'Status_Published', event_status: true, total: 0 },
    { id: this.EVENT_STATUS.SAVED, name: 'Armazenado', icon: 'Share2Icon', i18n: 'Status_Stored', event_status: true, total: 0 },
    { id: this.EVENT_STATUS.SCHEDULED, name: 'Agendado', icon: 'SendIcon', i18n: 'Status_Scheduled', event_status: true, total: 0 },
    { id: this.EVENT_STATUS.CANCELED, name: 'Cancelado', icon: 'AlertCircleIcon', i18n: 'Status_Canceled', event_status: true, total: 0 },
    { id: this.EVENT_STATUS.EDITING, name: 'Editando', icon: 'Edit3Icon', i18n: 'Status_Editing', event_status: true, total: 0 },
    { id: this.EVENT_STATUS.DRAFT, name: 'Rascunho', icon: 'Edit2Icon', i18n: 'Status_Draft', event_status: true, total: 0 },
    { id: this.EVENT_STATUS.TEMPLATE, name: 'Template', icon: 'LayoutIcon', i18n: 'Template', event_status: true, total: 0 },
  ];

  static CHANNELS = {
    LEGACY: { id: 1, name: 'MDTP (Legado)' },
    APP: { id: 2, name: 'Aplicativo' },
    TWITTER: { id: 3, name: 'Twitter' },
    TELEGRAM: { id: 4, name: 'Telegram' },
    PLATFORM: { id: 5, name: 'Plataforma' },
    WORDPRESS: { id: 6, name: 'Wordpress' },
    PUBLIC_AREA: { id: 7, name: 'Área Publica' },
  };

  static USER_PROFILE = {
    ADMIN: 0,
    PUBLISHER: 1,
    JOURNALISM: 2,
    ATTENDANCE: 3,
    CONTRACT: 4,
    CONSULTING: 5,
    MARKETING: 6,
    COMMERCIAL: 7,
    EDITOR: 8,
  }

  static CLIENT_PROFILE = {
    SUBSCRIBER: 1,
    DEMO: 2,
    FREE: 3
  }

  static CLIENT_PROFILE_OBJ = [
    { id: this.CLIENT_PROFILE.SUBSCRIBER, name: 'Assinante' },
    { id: this.CLIENT_PROFILE.DEMO, name: 'Demonstração' },
    { id: this.CLIENT_PROFILE.FREE, name: 'Gratuito' }
  ]

  // ********* STORE MODULES NAME *******************
  static CALENDAR_APP_STORE_MODULE_NAME = 'calendar';
  static IMAGE_LIBRARY_STORE_MODULE_NAME = 'imageLib';
  static NEWS_STORE_MODULE_NAME = 'news';

  // ********* DROPDOWN PARAMS USER RELATIONSHIP TABLES *******************
  static PARAMS_USER_FILTER = 'user_filter';

  static MEDIA_MAX_SIZE = 20; // MB
  static MEDIA_VIDEO_MAX_SIZE = 10 * 1024; // 10 Gb
  static MEDIA_AUDIO_EXTENSIONS = ['mp3'];
  static MEDIA_VIDEO_EXTENSIONS = ['mp4'];
  static MEDIA_DOCUMENT_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsm', 'xlsx', 'pdf'];
  static MEDIA_IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg'];
  static MEDIA_DOCUMENT_TYPE = [
    { name: 'Imagem', values: ['png', 'jpg', 'jpeg'], img_name: 'jpg.svg' },
    { name: 'Documento', values: ['doc', 'docx'], img_name: 'doc.svg' },
    { name: 'Planilha', values: ['xls', 'xlsm', 'xlsx'], img_name: 'xls.svg' },
    { name: 'PDF', values: ['pdf'], img_name: 'pdf.svg' },
    { name: 'Audio', values: ['mp3'], img_name: 'audio.png' },
    { name: 'Video', values: ['mp4'], img_name: 'video.png' },
  ];

  static USERCONFIG_SEND_NEWS = [
    { name: 'Tags', field: 'tag' },
    { name: 'Chapéu', field: 'hat' },
    { name: 'Resumo', field: 'summary' },
    { name: 'Íntegra', field: 'content' },
    { name: 'Notícias Relacionadas', field: 'related_news' },
  ];

  static RELATED_NEWS_TYPE_TEXT = { name: 'Texto', value: 'text' };
  static RELATED_NEWS_TYPE_LINK = { name: 'Link', value: 'link' };
  static TYPE_MESSAGE_CHANNEL = [
    { name: 'Completo (Com titulo e chapeu)', value: 1 },
    { name: 'Caption (Sem titulo e sem chapeu)', value: 2 },
  ];

  static ZOOM_DEFAULT = "100%";
  static ZOOM_MEDIUM = "110%";
  static ZOOM_BIG = "125%";

  static SUBJECT_VIEWTYPE_CHECKBOX = 'checkbox';
  static SUBJECT_VIEWTYPE_LIST = 'list';

  static FILE_TYPE = ['thumb', 'image', 'document'];

  static USER_AGENCY = ['Agência CMA', 'Agência CMA LATAM', 'SAFRAS'];

  static DROPDOWN_ALL_OPTION = {
    id: 10000,
    name: 'Todos',
    originsName: []
  };

  static ORIGIN_STATUS = [
    { id: 0, name: 'Ativa' },
    { id: 1, name: 'Inativa' },
    { id: 2, name: 'Teste' },
    { id: 3, name: 'Cancelada' },
  ];

  static EVENT_SCHEDULE_TYPE = [
    { id: 1, name: 'Online' },
    { id: 2, name: 'Presencial' },
  ];

  static DISCLOSURE_TYPE_ENUM = {
    ANNOUNCEMENT: 1,
    INVITE: 2,
    ECONOMIC_CALENDAR: 3
  };

  static EVENT_SCHEDULE_DISCLOSURE_TYPE = [
    { id: this.DISCLOSURE_TYPE_ENUM.ANNOUNCEMENT, name: 'Anúncio', color: 'calendar-color-announcement' },
    { id: this.DISCLOSURE_TYPE_ENUM.INVITE, name: 'Convite', color: 'calendar-color-invite' },
  ];

  static ORIGIN_TYPE_YN = [
    { id: 0, name: 'Não' },
    { id: 1, name: 'Sim' },
  ];

  static USER_CATEGORIES_FIELD = {
    PUBLIC_AREA: 'public-area',
    PRIORITY: 'priority',
    HIGHLIGHT: 'highlight',
    LIVE: 'live',
    PUSH: 'push'
  };

  static NEWS_TYPE_ENUM = {
    NOTIFICATION: 'notification',
    NEWS: 'news',
    REPORT: 'report',
    ITRADE: 'itrade',
    CALENDAR: 'calendar',
    CLIMATE: 'climate',
    FLASHES: 'flashes',
    TVCAST: 'tvcast',
    PODCAST: 'podcast',
    EVENT: 'event',
  };

  static COUNTRY_ENUM = {
    BRAZIL: 1,
    USA: 2,
    SPANISH: 3,
    ARGENTINA: 4,
    PARAGUAY: 5,
    CHINA: 6,
    SINGAPORE: 7,
    MEXICO: 8,
    COLOMBIA: 9,
    PORTUGAL: 10,
  }


  static NEWS_TYPE_LIST = [
    { id: null, name: 'Todos', value: '', color: 'news-type-color-news', icon: 'CheckSquareIcon', i18n: 'All' },
    { id: this.NEWS_TYPE_ENUM.NEWS, name: 'Notícia', color: 'news-type-color-news', value: 'newsFields', icon: 'FileTextIcon', i18n: 'News' },
    { id: this.NEWS_TYPE_ENUM.REPORT, name: 'Relatório', color: 'news-type-color-report', value: 'reportFields', icon: 'ClipboardIcon', i18n: 'Report' },
    // { id: this.NEWS_TYPE_ENUM.CALENDAR, name: 'Calendário', color: 'news-type-color-calendar', value: 'calendarFields', icon: 'CalendarIcon', i18n: 'Event' },
    { id: this.NEWS_TYPE_ENUM.CLIMATE, name: 'Clima', color: 'news-type-color-climate', value: 'climateFields', icon: 'CloudIcon', i18n: 'Climate' },
    { id: this.NEWS_TYPE_ENUM.FLASHES, name: 'Pisca', color: 'news-type-color-flashes', value: 'flashesFields', icon: 'ZapIcon', i18n: 'Flashes' },
    { id: this.NEWS_TYPE_ENUM.TVCAST, name: 'TvCast', color: 'news-type-color-tvcast', value: 'tvFields', icon: 'TvIcon', i18n: 'TvCast' },
    { id: this.NEWS_TYPE_ENUM.PODCAST, name: 'Podcast', color: 'news-type-color-podcast', value: 'podcastFields', icon: 'MicIcon', i18n: 'Podcast' },
    { id: this.NEWS_TYPE_ENUM.EVENT, name: 'Event', color: 'news-type-color-event', value: 'eventFields', icon: 'CalendarIcon', i18n: 'Event' },
    // { id: this.NEWS_TYPE_ENUM.NOTIFICATION, name: 'Notificação', color: 'news-type-color-notification', value: 'notificationFields', icon: 'BellIcon', i18n: 'Notification' },
    // { id: this.NEWS_TYPE_ENUM.ITRADE, name: 'itrade', color: 'news-type-color-itrade', value: 'itradeFields', icon: 'DollarSignIcon', i18n: 'Itrade' },
  ];

  static LIST_TEMPLATE = [
    { id: null, name: 'Todos', value: '', icon: 'CheckSquareIcon', i18n: 'All' },
    { id: this.NEWS_LAYOUT.NEWS, name: 'Notícia', value: 'newsFields', icon: 'FileTextIcon', i18n: 'News' },
    { id: this.NEWS_LAYOUT.FLASHES, name: 'Pisca', value: 'flashesFields', icon: 'ZapIcon', i18n: 'Flashes' },
    { id: this.NEWS_LAYOUT.PODCAST, name: 'Podcast', value: 'podcastFields', icon: 'MicIcon', i18n: 'Podcast' },
    { id: this.NEWS_LAYOUT.TVCAST, name: 'TVCast', value: 'tvFields', icon: 'TvIcon', i18n: 'TvCast' },
    { id: this.NEWS_LAYOUT.REPORT, name: 'Relatório', value: 'reportFields', icon: 'ClipboardIcon', i18n: 'Report' },
    { id: this.NEWS_LAYOUT.EVENT, name: 'Event', value: 'eventFields', icon: 'CalendarIcon', i18n: 'Event' },
  ];

  static CONTENT_ENUM = {
    INFORMATIVE: 1,
    STATISTIC: 2,
    EXPORTS: 3,
    CONSULTING: 4,
    CONSULTING_SAFRAS_TV: 5,
    CONSULTING_SAFRAS_PODCAST: 6,
    CONSULTING_COURSES: 7,
    CONSULTING_SPEECHES: 8,
    CONSULTING_EXCHANGE: 9,
    NEWS: 10,
    ASK_ANALYST: 11,
    WEATHER: 12,
    PHYSICAL_MARKET: 13,
    FUTURE_MARKET: 14,
    INDICATIVE_MARKET: 15,
    EXCHANGE_MARKET: 16,
    ACTIVE_MARKET: 17,
    HEDGE_WHATS: 18,
    HEDGE_COMMODITIES: 19,
    HEDGE_CAMBIAL: 20,
    WHAT_IS_IT: 21,
    CALENDAR: 24
  }

  // static FUSO = ['-8','-7','-6','-5','-4','-3','-2','-1','0','1','2','3','4','5','6','7','8'];

  // ********* PDF *******************
  static PDF_PWD = 'smDfzswBm3ET8YUS';

  static DEFAULT_CONTENT_CONFIG_COLOR = '#149655';
}
